import React, { useEffect, useCallback, useState } from 'react'
import { fetchActionItems } from '../../Api/transcriptAndSummary'
import Feedback from '../Feedback/Feedback'
import { updateStatus } from '../../Api/dashboard'
import { useSelector } from 'react-redux'

const ActionItems = ({ eventId, firstMeetActionItems }) => {
  const [actionItems, setActionItems] = useState([])
  const [firstActionItems, setFirstActionItems] = useState(firstMeetActionItems)
  const user = useSelector((state) => state?.user?.data)
  let firstName = user?.name?.split(' ')[0]
  const fetchActionItemsData = useCallback(async () => {
    const apiResponse = await fetchActionItems(eventId)
    if (apiResponse?.length > 0) {
      setActionItems([...apiResponse])
    } else {
      setActionItems([])
    }
  }, [setActionItems, eventId])

  useEffect(() => {
    if (eventId) {
      fetchActionItemsData()
    }
  }, [eventId, fetchActionItemsData])

  const updateActionItemStatusHandler = useCallback(async (id, status) => {
    const apiResponse = await updateStatus(id, status)
    if (apiResponse) {
      fetchActionItemsData()
    }
  }, [])

  const updateFirstActionItemStatusHandler = (id, newStatus) => {
    const itemIndex = firstActionItems.findIndex((item) => item.id === id)
    if (itemIndex === -1) {
      // Action item not found
      return
    }
    // Create a new action item object with the updated status
    const updatedItem = {
      ...firstActionItems[itemIndex],
      status: newStatus,
    }
    // Create a new array with the updated action item
    const updatedItems = [
      ...firstActionItems.slice(0, itemIndex),
      updatedItem,
      ...firstActionItems.slice(itemIndex + 1),
    ]
    // Update the state with the new array of action items
    setFirstActionItems(updatedItems)
  }
  return (
    <div className='action-items-wrapper'>
      <div className='action-items'>
        {actionItems?.length > 0 ? (
          <ul>
            {actionItems.map((actionItem) => (
              <li
                key={actionItem.id}
                className={actionItem.status === 1 ? 'active' : ''}
              >
                <span
                  onClick={
                    actionItem?.status === 1
                      ? () => updateActionItemStatusHandler(actionItem.id, 0)
                      : () => updateActionItemStatusHandler(actionItem.id, 1)
                  }
                >
                  {actionItem.status === 1 ? '✔' : ''}
                </span>
                <p>
                  <strong>{actionItem.user}</strong> to {actionItem.item}
                </p>
              </li>
            ))}
          </ul>
        ) : firstActionItems?.length > 0 ? (
          <ul>
            {firstActionItems.map((actionItem) => (
              <li
                key={actionItem.id}
                className={actionItem.status === 1 ? 'active' : ''}
              >
                <span
                  onClick={
                    actionItem?.status === 1
                      ? () =>
                          updateFirstActionItemStatusHandler(actionItem.id, 0)
                      : () =>
                          updateFirstActionItemStatusHandler(actionItem.id, 1)
                  }
                >
                  {actionItem.status === 1 ? '✔' : ''}
                </span>
                <p>
                  <strong>
                    {firstName?.charAt(0).toUpperCase() + firstName?.slice(1)}
                  </strong>{' '}
                  to {actionItem.item}
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p className='placeholder'>No action items for this meeting!</p>
        )}
      </div>
      <Feedback
        reference_id={eventId}
        feedback_type={4}
        isActionItems={true}
        actionItemsTotal={actionItems?.length > 0 ? actionItems.length : 0}
      />
    </div>
  )
}

export default ActionItems
